import { useIntl } from "react-intl";

const EmployeeDirectory = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "ConfluencePricingPageTeam24.features.employeeDirectory.title",
            defaultMessage: "Employee directory for people and teams"
        }),
        body: intl.formatMessage({
            id: "ConfluencePricingPageTeam24.features.employeeDirectory.body",
            defaultMessage:
                "Know who you’re working with and what they're working on."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
        </div>
    );
};

export default EmployeeDirectory;
